import { render, staticRenderFns } from "./TopSeller.vue?vue&type=template&id=f4a98176&scoped=true&"
import script from "./TopSeller.vue?vue&type=script&lang=js&"
export * from "./TopSeller.vue?vue&type=script&lang=js&"
import style0 from "./TopSeller.vue?vue&type=style&index=0&id=f4a98176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a98176",
  null
  
)

export default component.exports